import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AssessmentForm from "./pages/AssessmentForm";
import ReportPage from "./pages/ReportPage";
import Users from "./pages/Users";
import CRM from "./pages/CRM";
import Clients from "./pages/Clients";
import FollowUps from "./pages/FollowUps";
import OrgSettings from "./pages/OrgSettings";
import PublicStatus from "./pages/PublicStatus";
import AuditorShare from "./pages/AuditorShare";
import TemplateLibrary from "./pages/TemplateLibrary";
import Layout from "./components/Layout";
import "./App.css";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#0D1B2A]">
        <div className="text-sm tracking-wider uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/status/:token" element={<PublicStatus />} />
          <Route path="/audit/:token" element={<AuditorShare />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/new" element={<Protected><AssessmentForm mode="new" /></Protected>} />
          <Route path="/assessment/:id" element={<Protected><ReportPage /></Protected>} />
          <Route path="/assessment/:id/edit" element={<Protected><AssessmentForm mode="edit" /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="/crm" element={<Protected><CRM /></Protected>} />
          <Route path="/clients" element={<Protected><Clients /></Protected>} />
          <Route path="/follow-ups" element={<Protected><FollowUps /></Protected>} />
          <Route path="/templates" element={<Protected><TemplateLibrary /></Protected>} />
          <Route path="/settings" element={<Protected><OrgSettings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
